import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Space, Tooltip } from "antd";
import Highlighter from "react-highlight-words";
import React from "react";
export class SearchColumn {
  constructor(
    searchText,
    setSearchText,
    searchedColumn,
    setSearchedColumn,
    searchInput
  ) {
    this.searchText = searchText;
    this.setSearchText = setSearchText;
    this.setSearchedColumn = setSearchedColumn;
    this.searchedColumn = searchedColumn;
    this.searchInput = searchInput;
  }

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setSearchText(selectedKeys[0]);
    this.setSearchedColumn(dataIndex);
  };

  handleReset = (clearFilters, confirm) => {
    clearFilters();
    this.setSearchText("");
    confirm();
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={this.searchInput}
          placeholder={`جستوجو در ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            جستجو
          </Button>
          <Button
            onClick={() =>
              clearFilters && this.handleReset(clearFilters, confirm)
            }
            size="small"
            style={{
              width: 90,
            }}
          >
            حذف
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              this.setSearchText(selectedKeys[0]);
              this.setSearchedColumn(dataIndex);
            }}
          >
            فیلتر
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      `${record[dataIndex]}`.toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      this.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[this.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
}
export const LongColumn = {
  ellipsis: {
    showTitle: false,
  },
  render: (address) => (
    <Tooltip placement="topRight" title={address}>
      {address}
    </Tooltip>
  ),
};
